import React from "react";
import "./GenerativeHero.css";

export default function GenerativeHero() {
  return (
    <div id="generative-hero" className="generativemainclass">
      <div className="left">
        <h1>
      Reinvent your enterprise with the power of </h1>
      <h1 className="strong">Generative AI</h1>
        <p>
        Generative AI drives unprecedented enterprise productivity and growth, requiring a secure digital core, responsible AI use, and balanced investment in technology and people.
        </p>
      </div>
    </div>
  );
}
